// extracted by mini-css-extract-plugin
module.exports = {"rules":"LegalDocument_rules__tXtPt","policy":"LegalDocument_policy__7F7JS","divider":"LegalDocument_divider__95ZBJ","signature":"LegalDocument_signature__Hlezp"};